// NOTE: This hardcoded declaration duplicates styles from `../styles/base/customizations-${import.meta.env.VITE_THEME}.scss`
// make sure if those are updated, this is updated as well.
const THEME_CONFIGS = {
  chitowntrainer: {
    primaryColor: '#8ec73f',
    gradientStart: '#c2e673',
    gradientStop: 'rgba(142, 199, 63, 0.1)',
    black300: '#8d8c8c',
    black500: undefined,
    black800: undefined,
    red100: undefined,
    red200: undefined,
    red500: undefined,
    grey200: undefined,
    grey300: undefined,
    grey400: undefined,
    grey800: undefined,
    green500: undefined,
    blue500: undefined,
    baseWhite: undefined,
    purple500: undefined,
  },
  elevatedliving: {
    primaryColor: '#000000',
    gradientStart: '#ecc08b',
    gradientStop: 'rgba(194, 153, 109, 0.1)',
    black300: '#8d8c8c',
    black500: '#646464',
    black800: '#282828',
    red100: '#fbf0f0',
    red200: '#f5d4d2',
    red500: '#ce2c21',
    grey200: '#f6f5f5',
    grey300: '#f0efef',
    grey400: '#eae9e9',
    grey800: '#c9c8c8',
    green500: '#548671',
    blue500: '#5857e7',
    baseWhite: '#ffffff',
    purple500: '#aa32de',
  },
}

const {
  primaryColor,
  gradientStart,
  gradientStop,
  black300,
  black500,
  black800,
  red100,
  red200,
  red500,
  grey200,
  grey300,
  grey400,
  grey800,
  green500,
  blue500,
  baseWhite,
  purple500,
} = THEME_CONFIGS[import.meta.env.VITE_THEME]

export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
export const LINK_REGEX =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/
export const DIGIT_REGEX = /[^0-9]/g

export const BOOKING_TYPE_IMAGE_SIZE = 10000000

export const SERVICE_ICONS = [
  'volleyball',
  'sports',
  'pool',
  'shoe',
  'jumprope',
  'whistle',
  'glove',
  'timer',
  'darts',
  'trophy',
  'medal',
  'pitch',
  'box',
  'meditate',
]

export const BOOKING_TYPES_ICONS = [
  'housekeeping',
  'personalTraining',
  'massage',
  'nutrition',
  'mealDelivery',
  'dogWalking',
  'petVisit',
  'dogGrooming',
  'smarthome',
  'tvMounting',
  'handyman',
  'closetAudit',
  'catSitting',
  'declutter',
  'furnitureAssembly',
  'nails',
  'hair',
  'skinTreatments',
  'packingEcoBox',
  'moving',
]

export const SERVICE_COLORS = [
  '#86aee3',
  '#5984af',
  '#3e8c82',
  '#9dd84f',
  '#82b63f',
  '#dbb512',
  '#ffae3a',
  '#e77f00',
  '#d26100',
  '#b10000',
  '#00a1e3',
  '#ff9fa2',
  '#d8444a',
  '#d9beb2',
  '#947e76',
  '#b7b8ed',
  '#8587bb',
  '#f1acef',
  '#9f7a9e',
  '#b200e7',
  '#d26200',
  '#d29800',
]

export const SERVICE_CATEGORIES = [
  'Personal Training',
  'Group Training',
  'Massage Therapy',
  'Home Services',
  'Pet Services',
  'Handyman Services',
  'Moving Services',
  'Beauty Services',
  'Nutrition Services',
  'Gift',
]

const removeQuotesFromSassVars = (val) => val?.replace("'", '').replace("'", '')

export const APP_COLORS = {
  primary: removeQuotesFromSassVars(primaryColor),
  black300: removeQuotesFromSassVars(black300),
  black500: removeQuotesFromSassVars(black500),
  black800: removeQuotesFromSassVars(black800),
  red100: removeQuotesFromSassVars(red100),
  red200: removeQuotesFromSassVars(red200),
  red500: removeQuotesFromSassVars(red500),
  grey200: removeQuotesFromSassVars(grey200),
  grey300: removeQuotesFromSassVars(grey300),
  grey400: removeQuotesFromSassVars(grey400),
  grey800: removeQuotesFromSassVars(grey800),
  green500: removeQuotesFromSassVars(green500),
  blue500: removeQuotesFromSassVars(blue500),
  baseWhite: removeQuotesFromSassVars(baseWhite),
  purple500: removeQuotesFromSassVars(purple500),
}

export const GRAPH_COLORS = {
  primary: APP_COLORS.primary,
  start: removeQuotesFromSassVars(gradientStart),
  stop: removeQuotesFromSassVars(gradientStop),
}

export const daysOfWeek = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

export const csvReservationsFields = [
  {
    label: 'Date',
    value: 'date',
  },
  {
    label: 'Time',
    value: 'time',
  },
  {
    label: 'Amenity',
    value: 'amenity',
  },
  {
    label: 'Duration',
    value: 'duration',
  },
  {
    label: 'Price',
    value: 'price',
  },
  {
    label: 'Refund',
    value: 'refund',
  },
  {
    label: 'First Name',
    value: 'firstName',
  },
  {
    label: 'Last Name',
    value: 'lastName',
  },
  {
    label: 'Unit #',
    value: 'unit',
  },
  {
    label: 'Phone #',
    value: 'phone',
  },
  {
    label: 'Email',
    value: 'email',
  },
]

export const TIMEZONES = {
  PT: 'America/Los_Angeles',
  MT: 'America/Denver',
  CT: 'America/Chicago',
  ET: 'America/New_York',
  AZ: 'US/Arizona',
}

export const PASSWORD_SYMBOLS_AT_LEAST = 8

export const ONE_DAY_DURATION = 86400000 // (24 * 60 * 60 * 1000)
export const SECOND = 1000
export const ONE_HOUR_DURATION = 60
export const ONE_HOUR = 1
export const MINUTE = SECOND * 60

export const CALENDAR_RANGE_PADDING_DAYS = 7

export const NAVIGATION_LABELS = {
  NEW: 'NEW',
  COMING_SOON: 'COMING SOON',
  BETA: 'BETA',
  HIDDEN: 'HIDDEN',
}
